<template>
  <div class="nomination-review">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader v-if="nominationType === 'received'" name="Nomination Received"></ContentHeader>
        <ContentHeader v-else name="Nomination Sent"></ContentHeader>
        <div class="pt-2 mb-3" v-if="this.nomination.isteamaward[0] !== undefined && this.nomination.isteamaward[0] == 'true'">
          <h4 class="text-black-50" v-if="nominationType === 'received'">You've been nominated as {{ nominationCategory }} </h4>
          <template v-else>
            <h4 class="text-black-50" v-if="nominationCategory === 'Employee of the Month'">You've sent an {{ nominationCategory }} nomination to: </h4>
            <h4 class="text-black-50" v-else-if="nominationCategory === 'Team of the Month'">You've sent a {{ nominationCategory }} nomination to: </h4>
          </template>
          <BR/>
          <h5>Nominated Team Members:</h5>
          <ul>
            <li v-for="teams in nomination.nominationteam[0]" v-bind:key="teams.member_slug">
              <h6>
                <span class="text-black-50"><i class="fas fa-user fa-fw"></i> Name:</span>
                <a href="#">{{teams.member_name}}</a>
              </h6>
              <h6><span class="text-black-50"><i class="fas fa-globe fa-fw"></i> Employee Number:</span> {{ teams.member_employee_number }}</h6>
              <h6><span class="text-black-50"><i class="fas fa-building fa-fw"></i> Company:</span> {{teams.member_company}}</h6>
            </li>
          </ul>
        </div>
        <div class="pt-2 mb-3" v-else>
          <h4 class="text-black-50" v-if="nominationType === 'received'">You've been nominated as {{ nominationCategory }} </h4>
          <template v-else>
            <h4 class="text-black-50" v-if="nominationCategory === 'Employee of the Month'">You've sent an {{ nominationCategory }} nomination to: </h4>
            <h4 class="text-black-50" v-else-if="nominationCategory === 'Team of the Month'">You've sent a {{ nominationCategory }} nomination to: </h4>
          </template>
          <BR/>
          <h5 class="">Nominee Details:</h5>
          <h6>
            <span class="text-black-50"><i class="fas fa-user fa-fw"></i> Name:</span>
            <a href="#">{{nomination.nominee_name[0]}}</a>
          </h6>
          <h6><span class="text-black-50"><i class="fas fa-building fa-fw"></i> Company:</span> {{nomination.nominee_company[0]}}</h6>
        </div>
        <hr>
        <h5>Nominator Details:</h5>
        <div class="pt-2 mb-3">
          <h6>
            <span class="text-black-50"><i class="fas fa-user fa-fw"></i> Name:</span>
            <a href="#">{{nomination._embedded.author[0].name}}</a>
          </h6>
          <h6><span class="text-black-50"><i class="fas fa-building fa-fw"></i> Company:</span> {{nomination.nominator_details[0][0]['employee-company']}}</h6>
          <h6><span class="text-black-50"><i class="fas fa-globe fa-fw"></i> On:</span> {{ nominationDate }}</h6>
        </div>
        <div class="mb-3" v-html="nomination.content.rendered"></div>
        <template v-for="docIdArray in nomination.supporting_documentation">
          <template v-for="docId in docIdArray">
            <router-link :key="docId" :to="'/supporting-documentation/' + docId" target="_blank" class="btn btn-primary mb-3">View Image of Employee Nominated </router-link><br>
          </template>
        </template>
        <hr>
        <div>
          <h4 class="text-black-30">Selection Period:</h4>
          {{ nomination.selectionperiod[0] }}
        </div>
        <hr>
        <div v-if="hierarchicalMessage.length > 1">
          <h4 class="text-black-30">Review Comments:</h4>
          <div class="hierarchicalMessage" v-for="messages in hierarchicalMessage" v-bind:key="messages.id">
            <template v-if="messages.project_sponsor_name === 'Exco2'">
              <span v-if="messages.project_sponsor_comment !== '' || messages.project_sponsor_status === 'Approve'">
                <h6><span class="text-black-50">{{workflowStagesLabel[workflowStages.indexOf(messages.project_sponsor_name.toLowerCase())]}}:</span></h6>
                <span>{{messages.project_sponsor_comment}}</span>
                <hr v-if="hierarchicalMessage.length > 1">
              </span>
            </template>
          </div>
        </div>
        <div v-if="!nominationAccepted">
          <div v-if="showSubstationFields">
            <h4 class="text-black-50 mb-4">Please complete the fields below in order to further substantiate your nomination.</h4>
            <FieldFileInput
              label="If applicable, please attach supporting documentation (Word, PowerPoint, video):"
              label-secondary="(Optional)"
              :is-required="false"
              v-on:addedFileinputContent="populateFieldInput($event)"
              error-class="">
            </FieldFileInput>
            <Field150Word
              label="Add comments:"
              label-secondary="(Optional)"
              :is-required="false"
              v-on:added150WordContent="populateFieldInput($event)"
              error-class="">
            </Field150Word>
            <FieldTagAdd
              v-if="nomination.isteamaward[0] != 'true'"
              label="Add 3 references for your nomination:"
              label-secondary="(Optional)"
              :is-required="false"
              placeholder="Enter employee name"
              v-on:addedFieldTagContent="populateFieldInput($event)"
              error-class="">
            </FieldTagAdd>
            <div class="row py-1">
              <div class="col offset-md-4 offset-lg-4 offset-xl-3">
                <div class="form-group form-check">
                  <input type="checkbox" class="form-check-input" id="terms" v-model="termsCheckbox" required>
                  <label for="terms" class="form-check-label">Accept the
                    <router-link to="/page/multichoice-recognition-terms-and-conditions" target="_blank">Terms &amp; Conditions</router-link>
                  </label>
                </div>
                <div v-if="termsNotAccepted" class="alert alert-danger">
                  Please accept the terms before Accepting or Declining a nomination
                </div>
              </div>
            </div>
            <div class="row pt-2 mb-4">
              <div class="col offset-md-4 offset-lg-4 offset-xl-3">
                <button type="button" class="btn btn-success btn-lg" v-on:click="acceptDecline('Accepted')">
                  <i class="far fa-thumbs-up fa-fw"></i> Accept
                </button>
                <button type="button" class="btn btn-danger btn-lg" v-on:click="acceptDecline('Declined')">
                  <i class="far fa-thumbs-down fa-fw"></i> Decline
                </button>
              </div>
            </div>
          </div>
          <div v-if="!showSubstationFields" role="alert" class="alert alert-success">{{acceptDeclineMsg}}</div>
        </div>
        <!-- <div v-if="nominationAccepted">
          <div v-if="nomination.isteamaward[0] != 'true'" role="alert" class="alert alert-success">
            You have <strong>{{nomination.nomination_approve_decline[0]}}</strong> this nomination.
          </div>
          <div v-else role="alert" class="alert alert-success">
            You have <strong>{{currentTeamMemberStatus[0].member_approve_reject}}</strong> this nomination.
            <div v-if="currentTeamMemberStatus[0].member_approve_reject !== 'Rejected'">Awaiting for your colleague!</div>
            <div v-else>Hence this nomination is <strong>{{currentTeamMemberStatus[0].member_approve_reject}}</strong>!</div>
          </div>
        </div> -->
        <!-- <div>
          <strong>Company</strong><br>
          {{nomination.nominee_company[0]}} //TODO: Email Notification
        </div> -->
        <div v-if="nomination.nomination_approve_decline[0] === 'Declined' && nomination.isteamaward[0] != 'true'">
          <strong>Your reason for declining</strong><br>
          {{nomination.nomination_decline_reason[0]}}
        </div>
        <div v-if="nomination.nomination_approve_decline[0] === 'Accepted' && nomination.isteamaward[0] != 'true'">
          <!--div v-if="nomination.substantiation_comments[0] !== ''">
            <strong>Your comments</strong><br>
            {{nomination.substantiation_comments[0]}}
          </div>
          <div v-if="nomination.substantiation_references[0] !== ''">
            <strong>Your references</strong><br>
            {{nomination.substantiation_references[0]}}
          </div-->
          <div v-if="nomination.substantiation_documentation[0] !== '' && nomination.substantiation_documentation[0] !== undefined">
            <br><router-link :to="'/supporting-documentation/' + nomination.substantiation_documentation[0]" target="_blank" class="btn btn-primary mb-3">Additional supporting documentation</router-link>
          </div>
        </div>
        <b-modal ref="chooseDepartment" id="chooseDepartment" title="Accepted Nomination">
          <h6>Please confirm your nomination by selecting your company</h6>
          <div class="form-check">
            <input class="form-check-input" name="company-select" v-model="userSubmittedCompany" value="Support Functions (BTO, CII, Corporate Affairs, EBS, Finance, HR, Legal, Regulatory, Strategy)" type="radio" id="cii">
            <label for="cii" class="form-check-label">Support Functions (BTO, CII, Corporate Affairs, EBS, Finance, HR, Legal, Regulatory, Strategy)</label>
          </div>
          <div class="form-check" v-if="nominationCategory === 'Employee of the Year'">
            <input class="form-check-input" name="company-select" v-model="userSubmittedCompany" value="Technology (Media Technology, Infosec &amp; tech governance, Media Operations)" type="radio" id="ss">
            <label for="ss" class="form-check-label">Technology (Media Technology, Infosec &amp; tech governance, Media Operations)</label>
          </div>
          <div class="form-check" v-if="nominationCategory !== 'Employee of the Year'">
            <input class="form-check-input" name="company-select" v-model="userSubmittedCompany" value="Technology (Media Technology, Infosec &amp; tech governance, Media Operations)" type="radio" id="ss">
            <label for="ss" class="form-check-label">Technology (Media Technology, Infosec &amp; tech governance, Media Operations)</label>
          </div>
          <div class="form-check" v-if="nominationCategory !== 'Employee of the Year'">
            <input class="form-check-input" name="company-select" v-model="userSubmittedCompany" value="Irdeto" type="radio" id="irdeto">
            <label for="irdeto" class="form-check-label">Irdeto</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" name="company-select" v-model="userSubmittedCompany" value="General Entertainment" type="radio" id="mal">
            <label for="mal" class="form-check-label">General Entertainment</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" name="company-select" v-model="userSubmittedCompany" value="SuperSport" type="radio" id="mcsa">
            <label for="mcsa" class="form-check-label">SuperSport</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" name="company-select" v-model="userSubmittedCompany" value="Connected Video" type="radio" id="gen">
            <label for="gen" class="form-check-label">Connected Video</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" name="company-select" v-model="userSubmittedCompany" value="DStv Media Sales" type="radio" id="tech">
            <label for="tech" class="form-check-label">DStv Media Sales</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" name="company-select" v-model="userSubmittedCompany" value="MCSA Customer Group & Customer Care" type="radio" id="hr">
            <label for="hr" class="form-check-label">MCSA Customer Group & Customer Care</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" name="company-select" v-model="userSubmittedCompany" value="MultiChoice Africa" type="radio" id="finance">
            <label for="finance" class="form-check-label">MultiChoice Africa</label>
          </div>
          <div slot="modal-footer" class="w-100">
            <button type="button" class="btn btn-primary float-right" v-on:click="updateNomination('Accepted')">Submit</button>
          </div>
        </b-modal>
        <b-modal ref="whyDeclined" id="whyDeclined" title="Declined Nomination">
          <h6>Please inform us why you've declined this nomination</h6>
          <div class="form-check">
            <input class="form-check-input" v-on:click="showOtherReason = false" v-model="nominationDeclineReason" value="Not interested" name="reason-decline" type="radio" id="interested">
            <label for="interested" class="form-check-label">Not interested</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" v-on:click="showOtherReason = false" v-model="nominationDeclineReason" value="Not applicable" name="reason-decline" type="radio" id="applicable">
            <label for="applicable" class="form-check-label">Not applicable</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" v-on:click="showOtherReason = false" v-model="nominationDeclineReason" value="I resigned" name="reason-decline" type="radio" id="resigned">
            <label for="resigned" class="form-check-label">I resigned</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" v-on:click="showOtherReason = true" v-model="nominationDeclineReason" value="Other" name="reason-decline" type="radio" id="other">
            <label for="other" class="form-check-label">Other</label>
            <textarea v-if="showOtherReason" v-model="otherReason" class="form-control" id="" rows="3" placeholder="Explain why in less than 50 words"></textarea>
            <small v-if="showOtherReason" class="float-right text-black-50">You have 50 words left</small>
          </div>
          <div slot="modal-footer" class="w-100">
            <button type="button" class="btn btn-primary float-right" v-on:click="updateNomination('Declined')">Submit</button>
          </div>
        </b-modal>
      </div>
    </transition>
  </div>
</template>

<script>
import ContentHeader from '@/components/ContentHeader'
import FieldFileInput from '@/components/FieldFileInput'
import Field150Word from '@/components/Field150Word'
import FieldTagAdd from '@/components/FieldTagAdd'
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import WordpressRestURI from '@/helpers/WordpressRestURI.js'
import SupportingDocumentation from '@/helpers/SupportingDocumentation.js'
import NominationNotification from '@/helpers/NominationNotification.js'
import PreContentHeader from '@/components/PreContentHeader'
import { mapGetters } from 'vuex'
export default {
  components: {
    PreContentHeader,
    ContentHeader,
    FieldFileInput,
    Field150Word,
    FieldTagAdd
  },
  computed: {
    ...mapGetters([
      'getProfileDetails'
    ])
  },
  data () {
    return {
      contentReady: false,
      contentLoadError: '',
      nomination: {},
      currentUserProfile: {},
      nominationCategory: '',
      showSubstationFields: true,
      acceptDeclineMsg: '',
      nominatedComments: '',
      nominatedSupportingDoc: '',
      nominatedReferences: '',
      termsCheckbox: false,
      termsNotAccepted: false,
      nominationAccepted: false,
      nominationDeclineReason: '',
      userSubmittedCompany: '',
      otherReason: '',
      showOtherReason: false,
      currentTeamMemberStatus: false,
      promoteStage: '',
      nominationDate: '',
      award: [],
      hierarchicalMessage: [],
      nominationType: ''
    }
  },
  created () {
    document.title = this.$route.name + ' - ThinkTank'
    var self = this
    if (self.$route.params.type) {
      self.nominationType = self.$route.params.type
    }
    console.log(' self.type ', self.nominationType)
    var usernameOptions = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('userToken'),
        'Content-Type': 'application/json'
      },
      json: true
    }
    WordpressRestAPI.endpointWithAuthetication(usernameOptions, 'users/me?context=edit')
      .then(function (userResponse) {
        self.currentUserProfile = userResponse.data
        console.log(' self.currentUserProfile ', self.currentUserProfile.meta, self.currentUserProfile.meta.communities)
        WordpressRestAPI.getViewContent('nomination/' + self.$route.params.id + '?_embed')
          .then(response => {
            self.workflowStages = WordpressRestURI.workflowStages
            self.workflowStagesLabel = WordpressRestURI.workflowStagesLabel
            self.nomination = response.data
            console.log(' self.nomination ', self.nomination, self.nomination.nominator_details, self.nomination.nominator_details[0], self.nomination.nominator_details[0][0], self.nomination.nominator_details[0][0]['employee-number'])
            if (self.nominationType && self.nominationType === 'received') {
              self.nomination.content.rendered = self.nomination.content.rendered.replace('<strong>Why are you nominating this person?</strong>', '<strong>Motivation for Nomination</strong>')
            } else if (self.nominationType && self.nominationType === 'sent' || self.nominationType === '') {
              if (self.nomination.nomination_event_category && self.nomination.nomination_event_category.includes(139)) {
                self.nomination.content.rendered = self.nomination.content.rendered.replace('<strong>Why are you nominating this person?</strong>', '<strong>Why are you nominating this team?</strong>')
              }
            }
            self.getDate()
            self.nominationCategory = response.data._embedded['wp:term'][1].map(x => x.name).filter(x => x !== 'VE Awards').join()
            self.contentReady = true
            self.nominationAccepted = response.data.nomination_approve_decline[0] !== 'Pending'
            if (self.nomination.isteamaward[0] === 'true') {
              self.currentTeamMemberStatus = self.nomination.nominationteam[0].filter(d => d.member_slug === self.currentUserProfile.slug)
              if (self.currentTeamMemberStatus.length > 0) {
                self.nominationAccepted = (self.currentTeamMemberStatus[0].member_approve_reject !== 'Pending')
              }
              var categorySlug = response.data.slug.split('-by')[0] // TODO: FIND A VALID SLUG
              WordpressRestAPI.getViewContent('nomination_event?slug=' + categorySlug + '&_embed')
                .then(response => {
                  self.award = response.data[0]
                })
                .catch(e => {
                  console.error(e)
                })
            }
            self.hierarchicalMessage = self.workflowStages.map( function(r) {
              return self.nomination.teamnominationworkflow[0].filter(t => t.project_sponsor_name.toLowerCase() === r)[0]
            })
            // Remove duplicate for 
            self.hierarchicalMessage = self.hierarchicalMessage.filter(function(t){ return t !== undefined })
          })
          .catch(e => {
            self.childContentLoadError = 'Oops! We had a problem with loading your nomination. Please try again later.'
            console.error(e)
          })
      })
      .catch(function (error) {
        console.error(error)
      })
  },
  methods: {
    getDate: function() {
      let d = this.nomination.date.split('T')
      let options = {year: "numeric", month: "short", day: "numeric"};
      this.nominationDate = new Intl.DateTimeFormat('en-US', options).format(new Date(d[0]))
    },
    addSupportingFieldsToNominationPost: function (postID) {
      var sendNomination = {
        method: 'POST',
        data: {
          substantiation_comments: this.nominatedComments,
          substantiation_references: this.nominatedReferences
        },
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }
      WordpressRestAPI.endpointWithAuthetication(sendNomination, 'nomination/' + postID)
        .then(function (response) {
          console.log(response)
        })
        .catch(function (e) {
          console.error(e)
        })
    },
    populateFieldInput: function (content) {
      if (content.label === 'If applicable, please attach supporting documentation (Word, PowerPoint, video):') {
        this.nominatedSupportingDoc = content.content
      }
      if (content.label === 'Add comments:') {
        this.nominatedComments = content.content
      }
      if (content.label === 'Add 3 references for your nomination:') {
        this.nominatedReferences = content.content.map(x => x.value).join()
      }
    },
    setDeclineReason: function () {
      if (this.nominationDeclineReason !== 'Other') {
        return this.nominationDeclineReason
      } else {
        return this.otherReason
      }
    },
    updateTeamNominationData: function (mediaID, sendNomination, status) {
      if (this.nomination.isteamaward.length > 0) {
        var self = this
        for (var i = 0; i < self.nomination.nominationteam[0].length; i++) {
          if (this.nomination.nominationteam[0][i].member_slug === this.currentUserProfile.slug) {
            if (self.nominatedSupportingDoc !== '') {
              sendNomination.data.nominationteam.push({
                'member_name': self.nomination.nominationteam[0][i].member_name,
                'member_approve_reject': (status === 'Accepted' ? 'Accepted' : 'Rejected'),
                'member_company': self.userSubmittedCompany,
                'member_employee_number': self.nomination.nominationteam[0][i].member_employee_number,
                'member_slug': self.nomination.nominationteam[0][i].member_slug,
                'member_comments': (status === 'Accepted' ? self.nominatedComments : self.setDeclineReason()),
                'member_document': mediaID
              })
            } else {
              sendNomination.data.nominationteam.push({
                'member_name': self.nomination.nominationteam[0][i].member_name,
                'member_approve_reject': (status === 'Accepted' ? 'Accepted' : 'Rejected'),
                'member_company': self.userSubmittedCompany,
                'member_employee_number': self.nomination.nominationteam[0][i].member_employee_number,
                'member_slug': self.nomination.nominationteam[0][i].member_slug,
                'member_comments': (status === 'Accepted' ? self.nominatedComments : self.setDeclineReason())
              })
            }
          } else {
            sendNomination.data.nominationteam.push({
              'member_name': self.nomination.nominationteam[0][i].member_name,
              'member_approve_reject': self.nomination.nominationteam[0][i].member_approve_reject,
              'member_company': self.nomination.nominationteam[0][i].member_company,
              'member_employee_number': self.nomination.nominationteam[0][i].member_employee_number,
              'member_slug': self.nomination.nominationteam[0][i].member_slug,
              'member_comments': self.nomination.nominationteam[0][i].member_comments,
              'member_document': self.nomination.nominationteam[0][i].member_document
            })
          }
        }
      }
    },
    updateTeamNomination: function (status, sendNomination) {
      sendNomination.data.nominationteam = []
      var self = this
      if (self.nominatedSupportingDoc !== '') {
        var formData = new FormData()
        formData.append('file', self.nominatedSupportingDoc)
        formData.append('title', 'Supporting documentation by ' + self.getProfileDetails.name)
        formData.append('caption', 'Supporting documentation by ' + self.getProfileDetails.name)
        var uploadMedia = {
          method: 'POST',
          processData: false,
          contentType: false,
          data: formData,
          headers: {
            'Authorization': localStorage.getItem('userToken'),
            'Content-Type': 'application/json'
          },
          json: true
        }
        WordpressRestAPI.endpointWithAuthetication(uploadMedia, 'media')
          .then(function (response) {
            self.updateTeamNominationData(response.data.id, sendNomination, status)
            WordpressRestAPI.endpointWithAuthetication(sendNomination, 'nomination/' + self.$route.params.id)
              .then(function (data) {
                self.showSubstationFields = false
                self.acceptDeclineMsg = 'You have ' + status + ' your nomination from ' + self.nomination._embedded.author[0].name
              })
              .catch(function (e) {
                console.error(e)
              })
          })
          .catch(function (e) {
            console.error(e)
          })
      } else {
        self.updateTeamNominationData(-1, sendNomination, status)
        WordpressRestAPI.endpointWithAuthetication(sendNomination, 'nomination/' + self.$route.params.id)
          .then(function (data) {
            self.showSubstationFields = false
            self.acceptDeclineMsg = 'You have ' + status + ' your nomination from ' + self.nomination._embedded.author[0].name
          })
          .catch(function (e) {
            console.error(e)
          })
      }
    },
    promoteNomiationtoNextStage: function (stage) {
      let emailBody = NominationNotification.nominationBodyProjectSponsorWithReview({
        reviewLink: WordpressRestURI.frontEndDomain + 'login/my-profile+review-manager+' + this.$route.params.id + '+' + stage,
        position: this.promoteStage
      })
      var emailNominationNotification = {
        method: 'POST',
        data: {
          to: this.nomination.teamnominationworkflow[0].filter(d => d.project_sponsor_name === stage)[0].project_sponsor_email,
          subject: 'You have been identified as ' + this.promoteStage + ' on ThinkTank',
          message: emailBody
        },
        json: true
      }

      WordpressRestAPI.sendEmail(emailNominationNotification)
        .then(function (response) {
          console.log(response.data)
        })
        .catch(function (e) {
          console.error(e)
        })
    },
    updateNomination: function (status) {
      var self = this
      var updateFinalTeamNomination = false
      var updateNominationStatus = false
      var sendNomination = {
        method: 'POST',
        data: {},
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }
      if (status === 'Accepted' && this.userSubmittedCompany !== '') {
        updateNominationStatus = true
        this.$refs.chooseDepartment.hide()
        if (self.nomination.isteamaward[0] === 'true') {
          self.updateTeamNomination(status, sendNomination)
        } else {
          sendNomination.data = {
            nomination_approve_decline: status,
            nominee_company: this.userSubmittedCompany
          }
        }
      } else if (self.setDeclineReason() !== '') {
        updateNominationStatus = true
        this.$refs.whyDeclined.hide()
        if (self.nomination.isteamaward[0] === 'true') {
          updateFinalTeamNomination = true
          self.updateTeamNomination(status, sendNomination)
        } else {
          sendNomination.data = {
            nomination_approve_decline: status,
            nomination_decline_reason: self.setDeclineReason()
          }
        }
      }
      // Only applicable to Team Awards
      if (self.nomination.isteamaward[0] === 'true' && !updateFinalTeamNomination) {
        var updateFinalTeamNominationObj = sendNomination.data.nominationteam.filter(d => d.member_approve_reject === 'Rejected' || d.member_approve_reject === 'Pending')
        // No Pending or Rejected nominees
        if (!(updateFinalTeamNominationObj.length > 0)) {
          updateFinalTeamNomination = !(updateFinalTeamNominationObj.length > 0)
          self.promoteStage = 'Line Manager'
        }
      }
      // Moved out to handle Active/Present reject case
      if (updateFinalTeamNomination) {
        sendNomination.data = {
          nomination_approve_decline: status
        }
      }
      if (updateNominationStatus)
      if (this.nomination.isteamaward[0] !== 'true' || updateFinalTeamNomination) {
        WordpressRestAPI.endpointWithAuthetication(sendNomination, 'nomination/' + self.$route.params.id)
          .then(function (response) {
            self.showSubstationFields = false
            if (self.nominatedSupportingDoc !== '' && self.nomination.isteamaward[0] !== 'true') {
              SupportingDocumentation.uploadSupportingDocumentation(self.$route.params.id, self.nominatedSupportingDoc, self.getProfileDetails.name)
            }
            if ((self.nominatedComments !== '' || self.nominatedReferences !== '') && self.nomination.isteamaward[0] !== 'true') {
              self.addSupportingFieldsToNominationPost(self.$route.params.id)
            }
            self.acceptDeclineMsg = 'You have ' + status + ' your nomination from ' + self.nomination._embedded.author[0].name
            // below Variable is only for Team Awards
            if (updateFinalTeamNomination) {
              self.promoteNomiationtoNextStage('Sponsor')
            } else if (self.nominationCategory.toLowerCase() === 'on the spot') {
              self.promoteStage = 'Line Manager'
              self.promoteNomiationtoNextStage('Manager')
            }
          })
          .catch(function (e) {
            console.error(e)
          })
      }
    },
    acceptDecline: function (status) {
      if (this.termsCheckbox || status === 'Declined') {
        self.termsNotAccepted = false
        if (status === 'Accepted') {
          this.$refs.chooseDepartment.show()
        } else {
          this.$refs.whyDeclined.show()
        }
      } else {
        this.termsNotAccepted = true
      }
    }
  },
  watch: {
    getProfileDetails (newDetails, oldDetails) {
      if (this.getProfileDetails.name !== this.nomination.nominee_name[0]) {
        this.$router.push('/')
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/routes/NominationReviewEmployeeAward.vue